module.exports = __webpack_public_path__ + "static/media/39.531f9f62.png";